import type { Component } from 'vue';
import type { MenuItemCommandEvent } from 'primevue/menuitem';
import type { RouteLocationRaw } from '#vue-router';

export interface SmoothDnDDropProps<T> {
    addedIndex?: number
    removedIndex?: number
    payload: T
}

export interface DropdownMenuItem {
    label?: string;
    labelKey?: string;
    icon?: string;
    iconImage?: string;
    href?: string;
    command?: ((event: MenuItemCommandEvent) => void);
    disabled?: boolean;
    subheader?: string;
    tooltip?: string;
}

export interface MenuItem {
    label?: string;
    labelKey?: string;
    icon?: string;
    href?: string | RouteLocationRaw;
    highlightedRoutesNames?: string[];
    externalLink?: boolean;
}

export interface MenuGroup {
    label?: string;
    labelKey?: string;
    icon?: string;
    items?: MenuItem[];
    href?: string | RouteLocationRaw
    highlightedRoutesNames?: string[];
}

export enum Position {
    TOP = 'top',
    LEFT = 'left',
    RIGHT = 'right',
    BOTTOM = 'bottom',
}

export enum ButtonType {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    OUTLINE_PRIMARY = 'OUTLINE_PRIMARY',
    OUTLINE_SECONDARY = 'OUTLINE_SECONDARY',
    OUTLINE_DANGER = 'OUTLINE_DANGER',
    LINK_PRIMARY = 'LINK_PRIMARY',
    LINK_DANGER = 'LINK_DANGER',
    LINK_UNDERLINE = 'LINK_UNDERLINE',
    WHITE = 'WHITE',
}

export interface ToastOptions {
    severity: 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast' | undefined;
    summary: string;
    detail: string;
    life: number;
    group?: string
}

export interface ConfirmationOptions {
    group: string;
    icon?: string;
    header?: string;
    message: string;
    accept: () => void;
    reject: () => void;
    rejectLabel?: string;
    acceptLabel?: string;
    acceptDisabled?: boolean;
    showRejectButton?: boolean;
}

export interface TabItem {
    icon: string;
    title: string;
    content: Component;
}

export type LayoutDirection = 'vertical' | 'horizontal';

export enum TextAlignment {
    LEFT ='left',
    CENTER = 'center',
    RIGHT = 'right'
}

export enum FontVariation {
    UNDERLINE = 'UNDERLINE',
    BOLD = 'BOLD',
    ITALIC = 'ITALIC'
}

export interface LabelledValue {
    value: string;
    label: string;
}

export interface MultiConfirmOptions {
    cancelLabel: string;
    message: string;
    header?: string;
    icon?: string;
    options: LabelledValue[]
}


export interface SelectedFile {
    binaryContent: Blob;
    fileName: string;
    size: number;
}
